import ApiService from "@/core/services/api.service";
import { responseError } from "@/core/mixin/shared";
import querystring from "querystring";

const URL = "reports";

export const BASE_URL = "api/reports";
export const MODULE_NAME = "REPORTS";
export const LOADING = `LOADING`;
export const ERROR = `ERROR`;
export const SUCCESS = `SUCCESS`;
export const CURRENT_ITEM = `CURRENT_ITEM`;
export const ITEMS = `ITEMS`;
export const ITEM = `ITEM`;

export const SET_LOADING = `M/LOADING`;
export const SET_ERROR = `M/ERROR`;
export const SET_SUCCESS = `M/SUCCESS`;
export const SET_ITEMS = `M/ITEMS`;
export const SET_ITEM = `M/ITEM`;
export const SET_CURRENT_ITEM = `M/CURRENT_ITEM`;
export const RESET_VALUES = `M/RESET_VALUES`;

// ACTIONS
export const GET_ITEMS = `GET_ITEMS`;
export const GET_USER = `GET_USER`;
export const UPDATE_USER = `UPDATE_USER`;
export const UPDATE_USER_PHOTO = `UPDATE_USER_PHOTO`;
export const IMPORT_USERS = `IMPORT_USERS`;
export const EXPORT_USERS = `EXPORT_USERS`;
export const CREATE_ITEM = `CREATE_ITEM`;

const state = {
  items: [],
  item: {},
  currentItem: {},
  loading: false,
  error: null,
  success: null,
};

const getters = {
  [LOADING]: (state) => {
    return state.loading;
  },
  [ERROR]: (state) => {
    return state.error;
  },
  [SUCCESS]: (state) => {
    return state.success;
  },
  [ITEMS]: (state) => {
    return state.items;
  },
  [CURRENT_ITEM]: (state) => {
    return state.currentItem;
  },
  [ITEM]: (state) => {
    return state.item;
  },
};

const mutations = {
  [SET_LOADING]: (state, payload) => {
    state.loading = payload;
  },
  [SET_ERROR]: (state, payload) => {
    state.error = payload ? responseError(payload) : null;
  },
  [SET_ITEMS]: (state, payload) => {
    state.items = payload;
  },
  [SET_SUCCESS]: (state, payload) => {
    state.success = payload;
  },
  [SET_CURRENT_ITEM]: (state, payload) => {
    state.currentItem = payload;
  },
  [SET_ITEM]: (state, payload) => {
    state.item = payload;
  },
  [RESET_VALUES]: (state) => {
    state.success = null;
    state.error = null;
    state.loading = false;
    state.currentItem = null;
  },
};

const actions = {
  [GET_ITEMS]: (context, payload) => {
    let url = payload.url || URL;
    let filters = payload.filters;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    return ApiService.get(`${url}?` + querystring.stringify(filters))
      .then((response) => {
        context.commit(SET_LOADING, false);
        return { status: true, data: response.data };
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
      });
  },
  [EXPORT_USERS]: (context, payload) => {
    let url = payload.url || URL;
    let filters = payload.filters;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    return ApiService.get(`${url}?` + querystring.stringify(filters))
      .then((response) => {
        context.commit(SET_LOADING, false);
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
      });
  },
  [IMPORT_USERS]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let contents = payload.contents;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    return ApiService.post(url, contents)
      .then(() => {
        context.commit(SET_ITEM, {});
        context.commit(SET_LOADING, false);
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
      });
  },
  [GET_USER]: (context, payload) => {
    let url = payload.url;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    return ApiService.get(url)
      .then((response) => {
        context.commit(SET_CURRENT_ITEM, response.data);
        context.commit(SET_LOADING, false);
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
      });
  },
  [UPDATE_USER]: (context, payload) => {
    let url = payload.url;
    let contents = payload.contents;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    context.commit(SET_SUCCESS, null);
    ApiService.put(url, contents)
      .then((response) => {
        context.commit(SET_LOADING, false);
        context.commit(SET_SUCCESS, true);
        context.commit(SET_CURRENT_ITEM, response.data);
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
        context.commit(SET_LOADING, false);
      });
  },
  [UPDATE_USER_PHOTO]: (context, payload) => {
    let url = payload.url;
    let contents = payload.contents;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    context.commit(SET_SUCCESS, null);
    ApiService.post(url, contents)
      .then((response) => {
        context.commit(SET_LOADING, false);
        context.commit(SET_SUCCESS, true);
        context.commit(SET_CURRENT_ITEM, response.data);
        // location.reload();
      })
      .catch((error) => {
        context.commit(SET_ERROR, error);
        context.commit(SET_LOADING, false);
        context.commit(SET_LOADING, false);
      });
  },
  [CREATE_ITEM]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let contents = payload.contents;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    context.commit(SET_SUCCESS, null);
    return ApiService.post(url, contents)
      .then(() => {
        context.commit(SET_ITEM, {});
        context.commit(SET_SUCCESS, true);
        context.commit(SET_LOADING, false);
      })
      .catch((response) => {
        context.commit(SET_ERROR, response);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
